import CourseCardSkeleton from "./CourseCardSkeleton"

/**
 * Skeleton pour CourseGrid
 * Affiche plusieurs CourseCardSkeleton dans une grille
 */
export default function CourseGridSkeleton({ count = 8 }) {
  return (
    <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
      {[...Array(count)].map((_, index) => (
        <CourseCardSkeleton key={index} index={index} />
      ))}
    </div>
  )
}
